import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { log } from "../../Helper";
import { additionalInfoURL } from "../utility/constants";
import { useUserInfo } from "../../common/user-context";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT } from "../../constants/constants";
import { Link } from "@deere/fuel-react";
import _ from 'lodash';


function LoadBuildDetailsPanel(props) {
  const { userData } = useUserInfo();

  const [details, setDetails] = useState(null);

  const { rowData } = props;

  useEffect(() => {
    fetchDetails(rowData);
  }, [rowData]);

  const fetchDetails = async (rowData) => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          "Access-Control-Allow-Origin": API_ROOT,
        },
      };

      const response = await fetch(
        additionalInfoURL +
        `${rowData.rowData.comarNo}/${rowData.rowData.orderYear}/${userData.userId}`,
        requestOptions,
      );
      if (response.status == "200") {
        const data = await response.json();
        setDetails(data);
      } else if (response.status == "404" || response.status == "500") {
        setDetails(JSON.parse(await response.text())["message"]);
      }
    } catch (error) {
      log(error);
    }
  };

  if (!details) {
    return <div className="!text-[12px]">Loading...</div>;
  } else if (
    details === "No data found" ||
    details === "Error occurred while fetching additional data"
  ) {
    return <div className="!text-[12px]">{details}</div>;
  }

  return (
    <Box className="border-2 border-solid border-gray-400 bg-white m-[5px] rounded-[10px]">
      {/* <Typography className="pt-[5px] !text-[14px] !underline">
        Additional Details for comar : {rowData.comarNo}
      </Typography> */}
      <div className=" inline-flex !text-[10px] p-[5px]">
      {Object.keys(details).map((key) => (
          !_.isEqual(key, "LINK_NAME") &&
          (<div className="pr-[20px]" key={key}>
            <Typography className="!text-[11px] !font-bold">
              {key
                .replace(/([a-z])([A-Z])/g, "$1 $2")
                .toLowerCase()
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")}
            </Typography>
            <Typography className="!text-[10px]">{_.isEqual(key, "GOOGLE_LINK") ? (<Link href={details[key] || "#"} target="_blank">{details['LINK_NAME']}</Link>) : (details[key] || "No data available")}
            </Typography>
          </div>)
        ))}
      </div>
    </Box>
  );
}
export default LoadBuildDetailsPanel;

